import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { trans } from '../../../../localization/index';
import PageTable, {
  PageTableCell,
  PageTableHeader,
  PageTableRow,
} from '../../../../components/Table/PageTable';
import {
  EnumExportReportStatus,
  EnumPagingMode,
  EnumReportType,
  EnumTypePushMQTT,
  findEnumById,
} from '../../../../constants/enum';
import {
  decodeUtf8,
  formatTSTimeDateView,
  getParameterByName,
  isEmptyObject,
} from '../../../../utils/utils';
import LoadingExport from './LoadingExport';

import TableEmpty from '../../../../components/Common/TableEmpty'


class ExportRestaurantTable extends Component {
  static contextTypes = {
    mqtt: PropTypes.object,
  };

  constructor(props, context) {
    super(props);
    const { mqtt } = context;
    mqtt.on('message', this.handleChangeStatus);
  }

  handleChangeStatus = (topic, rawMessage) => {
    const { setExportInfoRestaurant } = this.props;
    if (rawMessage.length === 0) {
      return;
    }
    const message = JSON.parse(decodeUtf8(rawMessage));
    const { link, merchant_report: merchantReport } = message;
    const type = getParameterByName('type', link);
    if (
      type === EnumTypePushMQTT.MERCHANT_REPORT.value &&
      !isEmptyObject(merchantReport)
    ) {
      setExportInfoRestaurant(merchantReport);
    }
  };

  static renderHeader() {
    const columns = [
      {
        id: 'number',
        label: trans('mod_export_header_stt'),
        width: '5%',
        textAlign: 'center',
      },
      {
        id: 'name',
        label: trans('mod_export_header_name'),
        width: '40%',
        textAlign: 'left',
      },
      {
        id: 'report_type',
        label: trans('mod_export_header_report_type'),
        width: '20%',
        textAlign: 'center',
      },
      {
        id: 'request_time',
        label: trans('mod_export_header_request_time'),
        width: '10%',
        textAlign: 'center',
      },
      {
        id: 'status',
        label: trans('mod_export_header_status'),
        width: '15%',
        textAlign: 'center',
      },
      {
        id: 'download_url',
        label: trans('mod_export_header_download_url'),
        width: '10%',
        textAlign: 'center',
      },
    ];

    return <PageTableHeader columns={columns} />;
  }

  renderRow = (row, index) => {
    const { getUrlExportRestaurant } = this.props;
    const {
      report_id: reportId,
      report_type: reportType,
      restaurants,
      request_time: requestTime,
      status,
    } = row;
    const restaurantName = restaurants
      .reduce((value, item) => `${value}, ${item.restaurant_name}`, '')
      .substring(2);
    const totalRestaurant = restaurants.length;
    const enumStatus = findEnumById(EnumExportReportStatus, status);
    return (
      <PageTableRow key={reportId}>
        <PageTableCell textAlign="center" className="col-stt">
          {index}
        </PageTableCell>
        <PageTableCell textAlign="left">
          {totalRestaurant > 1 ? (
            <span title={restaurantName}>
              <strong>{totalRestaurant}</strong>
              {` ${trans('pos_restaurant')}`}
            </span>
          ) : (
            <strong>{restaurantName}</strong>
          )}
        </PageTableCell>
        <PageTableCell textAlign="center">
          {trans(findEnumById(EnumReportType, reportType).description)}
        </PageTableCell>
        <PageTableCell textAlign="center">
          {formatTSTimeDateView(requestTime)}
        </PageTableCell>
        <PageTableCell textAlign="center">
          <strong className={enumStatus.color}>
            {trans(enumStatus.description)}
          </strong>
          {[
            EnumExportReportStatus.PENDING.id,
            EnumExportReportStatus.PROCESSING.id,
          ].includes(status) && <LoadingExport />}
        </PageTableCell>
        <PageTableCell textAlign="center">
          {status === EnumExportReportStatus.SUCCESS.id && (
            <button
              className="btn btn-white"
              onClick={() => getUrlExportRestaurant(reportId)}
            >
              {trans('mod_download')}
            </button>
          )}
        </PageTableCell>
      </PageTableRow>
    );
  };

  static renderEmpty() {
    return (
      <PageTableRow>
        <PageTableCell colSpan={20} noPadding>
          <TableEmpty txt="mod_export_restaurant_not_found" />
        </PageTableCell>
      </PageTableRow>
    );
  }

  render() {
    const { table, changePageSize, changeActivePage } = this.props;
    return (
      <PageTable
        className="order-table"
        paginationMode={EnumPagingMode.SELF_PAGING.id}
        table={table}
        renderHeader={ExportRestaurantTable.renderHeader}
        renderRow={this.renderRow}
        renderEmpty={ExportRestaurantTable.renderEmpty}
        changePageSize={changePageSize}
        changeActivePage={changeActivePage}
      />
    );
  }
}

export default ExportRestaurantTable;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/ExportRestaurant/components/ExportRestaurantTable.jsx